import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate, useSearchParams } from 'react-router-dom';
import { CalendarDays, CalendarRange } from 'lucide-react';

import { Modal } from '@/components/shared/modal';
import {
  Card,
  CardDescription,
  CardTitle,
} from '@/components/shared/shadcn-ui/card';

export const CopyMenuChooserModal = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const isModalOpen = Boolean(useMatch({ path: '/restaurant/menus/copy' }));
  const closeModal = () => {
    navigate(`/restaurant/menus?${searchParams.toString()}`, { replace: true });
  };

  const modes = [
    {
      key: 'day',
      icon: CalendarDays,
      title: t('menu.copy.day-title'),
      description: t('menu.copy.day-description'),
    },
    {
      key: 'week',
      icon: CalendarRange,
      title: t('menu.copy.week-title'),
      description: t('menu.copy.week-description'),
    },
  ];

  return (
    <Modal
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      title={t('menu.copy.title')}
      className="lg:max-w-[640px]"
    >
      <div className="grid gap-4 sm:grid-cols-2">
        {modes.map(({ key, icon: Icon, title, description }) => (
          <Card
            key={key}
            role="button"
            onClick={() =>
              navigate(
                `/restaurant/menus/copy/${key}?${searchParams.toString()}`,
              )
            }
            className="flex cursor-pointer flex-col items-center gap-3 p-6 text-center hover:ring-2 hover:ring-primary"
          >
            <Icon className="h-10 w-10 text-primary" />
            <CardTitle className="text-lg">{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </Card>
        ))}
      </div>
    </Modal>
  );
};
